import { TOKEN_KEY, LOGIN_ACCESS_USER_ID } from '../constant/web'
import Cookies from 'js-cookie'
import {FROZEN_KEY, OPENID_KEY} from "../constant/common";

/**
 * 微信扫码登录时，账号冻结返回的cookie
 * @returns
 */
export const getFrozen = () => Cookies.get(FROZEN_KEY)
export const removeFrozen = () => Cookies.remove(FROZEN_KEY)
/**
 * 微信扫码登录时返回的openid
 */

export const getOpenId = () => Cookies.get(OPENID_KEY)
export const removeOpenId = () => Cookies.remove(OPENID_KEY)
//token
export const getToken = () => Cookies.get(TOKEN_KEY)?.trim() || (localStorage.getItem(TOKEN_KEY) ?? '')
export const getUserId = () => Cookies.get(LOGIN_ACCESS_USER_ID)?.trim() || (localStorage.getItem(LOGIN_ACCESS_USER_ID) ?? '')